var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"f0WmPqmbWA3QODlbsu6gD"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';
import { sentryConfig } from './src/configs/sentry/constants/config';

Sentry.init({
  dsn: sentryConfig.dsn,
  environment: sentryConfig.environment,
  debug: sentryConfig.debug,
  sampleRate: sentryConfig.traceSamplingDefaultRate,
});
